import * as React from "react";
import type { SVGProps } from "react";
const SvgIcMoreOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={6} cy={12} r={2} fill="#040747" />
    <circle cx={12} cy={12} r={2} fill="#040747" />
    <circle cx={18} cy={12} r={2} fill="#040747" />
  </svg>
);
export default SvgIcMoreOptions;
